define(['jquery'], function ($) {
	"use strict";

	let PLUGIN_NAME = "busHire";

	let DEBUG = false;

	let DEFAULTS = {
		targetElementSelector:  '.js_busHire_target',
		targetNameElementSelector:  '.js_busHire_name_target'
	};

	/**
	 *
	 * @param element
	 * @param options
	 * @constructor
	 */
	let BusHire = function (element, options) {
		let self = this;
		self.element = element;
		self.$t = $(self.element);

		self._name = PLUGIN_NAME;
		self._defaults = DEFAULTS;

		self.options = $.extend(true, {}, DEFAULTS, options);

		if ( !$( self.options.targetElementSelector ).length ) {
			$.error("Argument error.");
		}

		self.initialise();
	};

	/**
	 * Init function
	 * @private
	 */
	BusHire.prototype.initialise = function () {
		let self = this;

		self.mapObjects();
		self.bindEvents();
	};

	BusHire.prototype.mapObjects = function () {
		let self = this;

		self.objects = {};
		self.objects.$targetInput = $( self.options.targetElementSelector );
		self.objects.$targetNameInput = $( self.options.targetNameElementSelector );
	};
	BusHire.prototype.bindEvents = function () {
		let self = this;

		clog( self.objects.$targetInput );

		self.$t.on("click." + self._name, function (evn) {
			clog(evn);
			let busId = self.$t.data('busHireId');
			self.objects.$targetInput.val( busId );
			let busName = self.$t.data('busHireName');
			self.objects.$targetNameInput.val( busName );
		});

	};

	let API = {};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 *        if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 *        if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		let args = arguments;

		return this.each(function () {
			let $this = $(this);

			// get plugin instance
			let plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new BusHire(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};

	// simple logger
	function clog(){
		if ( DEBUG && window.console ) {
			for ( let arg in arguments ) {
				console.log( arguments[arg] );
			}
		}
	}

});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.busHire.js